import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./Enterprise.scss";
import ManageCompliance from "../../assets/images/Manage compliance.png";
import WhiteLabel from "../../assets/images/White label.png";
import VirtualClassroom from "../../assets/images/Virtual classroom.png";
import Dashboard from "../../assets/images/dashboards.png";
import CertifyLearners from "../../assets/images/Certify learners.png";
import EmbraceCloud from "../../assets/images/Embrancecloud.png";
import Arrow from "../../assets/images/right-arrow.png";

import { useEffect } from "react";

function EnterpriseBenefits() {
  const { t } = useTranslation();
  const [arrowDisable, setArrowDisable] = useState(1);

  const ent_benefits = [
    {
      key: 0,
      title1: "Manage ",
      title2: "Compliance",
      title3: "",
      subTitle: "Effective Compliance Management & Training",
      desc: "Upload training modules provided by governments, professional associations and other regulatory bodies to ensure your employees complete required courses to maintain their licenses, your insurance status and everyone’s reputation.",
      image: ManageCompliance,
      link: "",
    },
    {
      key: 1,
      title1: "A ",
      title2: "White Label",
      title3: "Solution",
      subTitle: "Branding Made Easy: The Power of White Label Solutions",
      desc: "You’ve heard of a custom skin? It lets us create a look and feel in keeping with your brand, corporate identity and style guide. Keep all your digital spaces consistent with yslearn.in’s white label solution and your employees and customers will always feel at home.",
      image: WhiteLabel,
      link: "",
    },
    {
      key: 2,
      title1: "The ",
      title2: "Virtual Classroom",
      title3: "",
      subTitle:
        "Revolutionize Your Training: A Virtual Classroom for Business Training",

      desc: "yslearn.in’s virtual classroom comes with all the virtual tools required to teach a live lesson remotely, engage students and verify active learning. Our interactive white board, quiz tools and polls are accessible with a click.",
      image: VirtualClassroom,
      link: "",
    },
    {
      key: 3,
      title1: "Purpose-Built ",
      title2: "Dashboard",
      title3: "",
      subTitle:
        "Efficiently Monitor Your Training: The Power of a Customizable Dashboard",
      desc: "The data you need at a glance depends on your role in the training eco-system. yslearn.in features unique dashboards for students, instructors and administrators to get the information they need the moment they need it.",
      image: Dashboard,
      link: "",
    },
    {
      key: 4,
      title1: "Certify ",
      title2: "Learners",
      title3: "",
      subTitle: "Certify Your Team: Ensure Regulatory and Safety Compliance",
      desc: "Training completion has its own rewards. In highly-regulated industries and where tax authorities require proof of completion to issue rebates, the yslearn.in certificate tool will help you manage certification, expiry and re-certification processes.",
      image: CertifyLearners,
      link: "",
    },
    {
      key: 5,
      title1: "Embrace ",
      title2: "the Cloud",
      title3: "",
      subTitle: "Scalable Learning: Benefits of Cloud-Based LMS",
      desc: "Secure and flexible, our cloud-based enterprise-grade LMS can grow or contract to meet your current needs. As the number of user accounts and the amount of storage you require changes for each year, so can your service package. This feature makes yslearn.in the most cost-effective solution on the market.",
      image: EmbraceCloud,
      link: "",
    },
  ];

  useEffect(() => {
    if (window.innerWidth > 480) {
      let cards = document.querySelectorAll(".flip-card-inner");

      [...cards].forEach((card) => {
        card.addEventListener("click", () => {
          card.classList.toggle("is-flipped");
        });
      });
    }
  }, []);

  useEffect(() => {
    if (window.innerWidth > 480) {
      let card = document.getElementById("1st-card");
      const handleScroll = () => {
        if (window.pageYOffset > 1400 && window.pageYOffset < 1500) {
          card.classList.toggle("is-flipped");
          setTimeout(() => {
            card.classList.remove("is-flipped");
          }, 2000);
          window.removeEventListener("scroll", handleScroll);
        }
      };
      window.addEventListener("scroll", handleScroll);
    }
  }, []);

  const disableScroll = () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    window.onscroll = function () {
      window.scrollTo(scrollLeft, scrollTop);
    };
    return setTimeout(() => {
      window.onscroll = function () {};
    }, 100);
  };

  return (
    <div className="card-slider-container">
      <div className="power-of-smiklearn-title">
        {t("Before Enterprise Power of yslearn.in Title1")}
        <span>{t("Before Enterprise Power of yslearn.in Title2")}</span>
      </div>
      <div className="card-slider">
        <div className="flip-container card-slides">
          {ent_benefits?.map((item, key) => {
            return (
              <>
                <div
                  id={`card__${item.key + 1}`}
                  className="flip-card enterprise-card-slide"
                  key={key}
                >
                  <div
                    className={
                      window.innerWidth < 480
                        ? "flip-card-inner is-flipped"
                        : "flip-card-inner"
                    }
                    id="1st-card"
                  >
                    <div className="flip-card-front">
                      <div className="flip-img">
                        <img src={item.image} alt="" />
                      </div>
                      <div className="flip-header">
                        {item.title1} <span>{item.title2}</span> {item.title3}
                      </div>
                      <div className="flip-text-subtitle">{item.subTitle}</div>
                      <br />
                      <div className="read-more-ent">Read More</div>
                    </div>
                    <div className="flip-card-back">
                      <div className="flip-img">
                        <img src={item.image} alt="" />
                      </div>
                      <div className="flip-header-back">
                        {item.title1} <span>{item.title2}</span> {item.title3}
                      </div>{" "}
                      <div className="flip-text">{item.desc}</div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>
        <div className="card-slider-btn">
          <a onClick={disableScroll} href={`#card__${arrowDisable}`}>
            <span
              className="prev-arrow"
              onClick={() =>
                setArrowDisable(arrowDisable !== 1 ? arrowDisable - 1 : 1)
              }
            >
              <img
                className={
                  arrowDisable === 1 ? "a-disabled-prev-arrow" : "prev-arrow"
                }
                src={Arrow}
                alt="Prev-Arrow"
              />
            </span>
          </a>
          <a onClick={disableScroll} href={`#card__${arrowDisable}`}>
            <span
              className="next-arrow"
              onClick={() =>
                setArrowDisable(arrowDisable < 6 ? arrowDisable + 1 : 6)
              }
            >
              <img
                className={
                  arrowDisable === 6 ? "a-disabled-next-arrow" : "next-arrow"
                }
                src={Arrow}
                alt="Next-Arrow"
              />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default EnterpriseBenefits;
